document.addEventListener('DOMContentLoaded', function() {
  const grid = document.getElementById('galleryGrid');
  if (!grid) return;

  // Einfach nur die Bilder laden lassen
  const images = grid.querySelectorAll('img');
  images.forEach(img => {
    img.addEventListener('load', function() {
      // Bilder sind geladen
    });
  });
});
